import {
  loginConstants,
  globalConstants,
  centersConstants,
  globalSystemConstants,
  registrationConstants,
  profileConstants,
  StorageKeys,
} from "../../constants";
import {
  getUserPayload,
  getUserStatus,
  getSessionStorageItem,
  getLocalStorageItem,
} from "../../system";

//-------initializing the token from the browser
const payload = getUserPayload();
const accessToken = payload.token || globalConstants.EMPTY_STRING;
const userDocumentStatus = getUserStatus();
const initialState = {
  isAuthenticated: accessToken.length > 0,
  UserData: payload,
  emailVerification: {},
  spinnerActions: false,
  underReview: { value: false },
  countries: [],
  cities: [],
  registerUserData: {},
  registrationStatus: { message: "", userStatus: 0 },
  userDocumentStatus: userDocumentStatus,
  activeProfile: getLocalStorageItem(StorageKeys.activeRole),
  isLoginFromRegForm: false,
  showLoginModal: false
};

const taskReducer = (state = initialState, action) => {
  switch (action.type) {
    case loginConstants.EMAIL_VERIFIED:
      return {
        ...state,
        emailVerification: action.data,
      };
    case loginConstants.LOGIN + globalConstants.SUCCESS:
      return {
        ...state,
        UserData: action.data,
        isAuthenticated: true,
      };
    case registrationConstants.REGISTRATION_SUCCESS + globalConstants.SUCCESS:
      return {
        ...state,
        registrationStatus: action.data,
      };
    case registrationConstants.REGISTRATION_COUNTRIES + globalConstants.SUCCESS:
      return {
        ...state,
        countries: action.data,
      };
    case registrationConstants.REGISTRATION_CITIES + globalConstants.SUCCESS:
      return {
        ...state,
        cities: action.data,
      };

    case loginConstants.UNDER_REVIEW + globalConstants.SUCCESS:
      return {
        ...state,
        userDocumentStatus: action.data,
      };
    case loginConstants.SPINNER_ACTIVATE:
      return {
        ...state,
        spinnerActions: true,
      };
    case loginConstants.SPINNER_DEACTIVATE:
      return {
        ...state,
        spinnerActions: false,
      };
    case profileConstants.GET_ACTIVE_PROFILE:
      return {
        ...state,
        activeProfile: action.data,
      };
    case loginConstants.ISLOGIN_FROM_COMPT_REG_FORM:
      return {
        ...state,
        isLoginFromRegForm: action.data,
      };
    case centersConstants.SET_CENTER_STATUS_IN_LOGIN_REDUCER:
      return {
        ...state,
        UserData: { ...state.UserData, centerStatus: action.data },
      };
    case centersConstants.SET_ISMEMBER_STATUS_IN_LOGIN_REDUCER:
      return {
        ...state,
        UserData: {
          ...state.UserData,
          user: { ...state.UserData.user, isMembershipHolder: action.data },
        },
      };
    case centersConstants.SET_ISFREELANCER_STATUS_IN_LOGIN_REDUCER:
      return {
        ...state,
        UserData: {
          ...state.UserData,
          user: { ...state.UserData.user, role: action.data },
        },
      };
    case loginConstants.SHOW_LOGIN_MODAL:
      return {
        ...state,
        showLoginModal: action.data,
      };
    case loginConstants.LOGOUT:
      return {
        ...state,
        isAuthenticated: false,
      };
    default:
      return state;
  }
};

export default taskReducer;
